export const parseOrders = (orderList: any, serviceType: string) => {
  if (!orderList?.orders) {
    return []
  }
  if (serviceType === 'offerings') {
    let offeringOrders: any[] = []
    orderList?.orders?.map((order: any) => {
      const {
        booking_whatsapp_number,
        booking_member_data,
        is_opted_for_prasad,
        booking_address,
        ...rest
      } = order
      offeringOrders?.push(rest)
    })
    const parsedOfferingsOrderData = orderList?.orders?.map((order: any) => ({
      ...order,
      items: order?.items?.map((item: any) => ({
        ...item,
        meta_data: {
          ...item?.meta_data,
          video_url: [item?.meta_data?.video_url],
        },
      })),
    }))
    return parsedOfferingsOrderData
  } else {
    let trimmedMobileNumber: string
    let trimmedWhatsAppNumber: string

    const parsedOrderData = orderList?.orders.map((order: any) => {
      const hasDeliverable = order?.add_ons?.some(
        (obj: any) => obj.deliverable === true,
      )
      const mobile = order?.booking_member_data?.[0]?.mobile_number ?? ''
      const whatsAppNumber = order?.booking_whatsapp_number ?? ''
      if (mobile?.length > 10 && mobile?.includes('+91')) {
        trimmedMobileNumber = mobile?.replace(/^\+91/, '')
      } else {
        trimmedMobileNumber = mobile
      }
      if (whatsAppNumber?.length > 10 && whatsAppNumber?.includes('+91')) {
        trimmedWhatsAppNumber = whatsAppNumber?.replace(/^\+91/, '')
      } else {
        trimmedWhatsAppNumber = whatsAppNumber
      }
      const bookingMemberData = order?.booking_member_data
      const parsedMemberData = bookingMemberData
        ? [
            {
              ...bookingMemberData[0],
              mobile_number: trimmedMobileNumber,
              whatsapp_number: trimmedWhatsAppNumber,
            },
            ...bookingMemberData.slice(1),
          ]
        : null
      return {
        ...order,
        is_deliverable: hasDeliverable,
        booking_whatsapp_number: trimmedWhatsAppNumber,
        booking_member_data: parsedMemberData,
        items: order?.items?.map((item: any) => ({
          ...item,
          meta_data: {
            ...item?.meta_data,
            video_url: [item?.meta_data?.video_url],
          },
        })),
      }
    })
    return parsedOrderData
  }
}

export const actionMapping: any = {
  offeringUserName: 'UPDATE_OFFERING_USER_NAME',
  memberData: 'UPDATE_BOOKING_MEMBER_DATA',
  sku: 'UPDATE_INVENTORY_VIDEO',
  address: 'UPDATE_PRASAD_DETAILS',
  refund: 'REFUND',
  whatsappNumber: 'UPDATE_WHATSAPP_NUMBER',
  trackingData: 'UPDATE_TRACKING_DATA',
  deliveryStatus: 'UPDATE_DELIVERY_STATUS',
}

export const orderPayload = (
  order: any,
  action: string,
  country_code?: string,
) => {
  switch (action) {
    case 'offeringUserName':
      return {
        offering_user_name: order?.offering_user_name,
      }
    case 'sku':
      return {
        inventory_video_data: {
          inventory_id: order?.id,
          media: {
            media_type: order?.meta_data?.media_type,
            media_url: order?.meta_data?.video_url?.[0],
          },
        },
      }
    case 'memberData':
      if (
        country_code === 'IN' &&
        order?.booking_member_data?.[0]?.same_as_mobile_number
      ) {
        if (
          order?.booking_member_data?.[0]?.mobile_number !==
          order?.booking_member_data?.[0]?.whatsapp_number
        ) {
          return {
            error: {
              status: true,
              code: 'number_mismatch',
            },
          }
        }
      }
      return {
        booking_member_data: order?.booking_member_data
          ?.filter((item: any) => item?.full_name !== '')
          ?.map((member: any, index: number) => {
            if (index === 0) {
              if (country_code === 'IN') {
                return {
                  full_name: member?.full_name,
                  gotra: member?.gotra,
                  mobile_number: `+91${member?.mobile_number}`,
                  whatsapp_number: `+91${member?.whatsapp_number}`,
                  same_as_mobile_number: member?.same_as_mobile_number,
                }
              } else {
                return {
                  full_name: member?.full_name,
                  gotra: member?.gotra,
                }
              }
            } else {
              return {
                full_name: member?.full_name,
              }
            }
          }),
      }
    case 'address':
      return {
        prasad_details: {
          address: order?.booking_address,
        },
      }
    case 'whatsappNumber':
      return {
        whatsapp_number: `+91${order?.booking_whatsapp_number}`,
      }
    case 'trackingData':
      if (order?.delivery_data?.is_manual_update) {
        return {
          tracking_data: {
            tracking_id: String(order?.delivery_data?.m_tracking_id),
            courier_name: order?.delivery_data?.m_courier_name,
          },
        }
      } else {
        return {
          tracking_data: {
            tracking_id: String(order?.delivery_data?.tracking_id),
            courier_name: order?.delivery_data?.result?.courier_name,
          },
        }
      }

    case 'deliveryStatus':
      return {
        delivery_status: order?.delivery_status,
      }
  }
}

export const orderTypeFilterOptions = [
  {
    label: 'Offerings',
    value: 'offerings',
  },
  {
    label: 'Offerings Delivery',
    value: 'offerings_delivery',
  },
]

export const deliveryStatusFilters = [
  {
    label: 'Deliverable',
    value: 'deliverable',
  },
  {
    label: 'Order Created',
    value: 'order_created',
  },
  {
    label: 'Order Failed',
    value: 'order_failed',
  },
  {
    label: 'Pickup Initiated',
    value: 'pickup_initiated',
  },
  {
    label: 'Picked Up',
    value: 'picked_up',
  },
  {
    label: 'Intransit',
    value: 'intransit',
  },
  {
    label: 'Delivery Initiated',
    value: 'delivery_initiated',
  },
  {
    label: 'Delivery Success',
    value: 'delivery_success',
  },
  {
    label: 'Delivery Failed',
    value: 'delivery_failed',
  },
]

export const orderStatusFilters = [
  {
    label: 'Any',
    value: 'any',
    disabled: true,
  },
  {
    label: 'Booked',
    value: 'booked',
  },
  {
    label: 'Refunded',
    value: 'refunded',
  },
  {
    label: 'Completed',
    value: 'completed',
  },
  {
    label: 'Live',
    value: 'live',
  },
]
